/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseOfCoursePriceParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['tenantId', codecString, 'tenant_id'],
    ['name', codecString],
]);
export class CourseOfCoursePrice extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseOfCoursePriceParser.decode(input).map(res => new CourseOfCoursePrice(res));
    }
    static unsafeDecode(input) {
        return CourseOfCoursePrice.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseOfCoursePriceParser.encode(data);
    }
    static schema() {
        return CourseOfCoursePriceParser.schema();
    }
}
